module.exports = __webpack_public_path__ + "assets/3e69fef757bb16927b530f9722952ab0.mp3";